import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
// import { TipologiaRegistrazioneDto } from '@ideapa/common-dto';
import { FieldType, FilterType } from '@ideapa/common-interfaces';
import { Cr, Es, StatoRecord } from '@ideapa/common-utils';

export const ENTITY = 'cofi';
export const ENTITY_PLURAL = 'Importazione dati Co.fi.';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Codice Tipologia',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'tipologia.codice',
    initialHideColumn: true,
    hideFilter: true,
    exportHideColumn: true,
  },
  {
    elementLabel: 'ES',
    filterType: FilterType.enum,
    fieldType: FieldType.enum,
    field: 'es',
    elementValues: Es,
    maxWidth: 70,
  },
  {
    elementLabel: 'Data',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'dataOperazione',
    minWidth: 100,
  },
  {
    elementLabel: 'Piano Finanziario',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoFinanziario.codice',
  },
  {
    elementLabel: 'N. Operazione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'numeroOperazione',
    minWidth: 120,
    maxWidth: 120,
  },
  {
    elementLabel: 'Capitolo',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'capitolo',
    minWidth: 120,
  },
  {
    elementLabel: 'Descrizione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'descrizione',
  },
  {
    elementLabel: 'Importo',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'importo',
    contentAlignment: ContentAlignmentEnum.Right,
  },
  {
    elementLabel: 'C/R',
    filterType: FilterType.enum,
    fieldType: FieldType.enum,
    field: 'swCr',
    elementValues: Cr,
    initialHideColumn: true,
    maxWidth: 70,
  },
  {
    elementLabel: 'Programma',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'programma.descrizione',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Rate',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swRate',
    initialHideColumn: true,
    maxWidth: 70,
  },
  {
    elementLabel: 'Stato',
    filterType: FilterType.enum,
    fieldType: FieldType.enum,
    field: 'stato',
    initialHideColumn: true,
    elementValues: StatoRecord,
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
